export const flag = process.env.NODE_ENV === 'production';
export const proPrefix = window.dataManage.proPrefix; // 生产环境
export const devPrefix = window.dataManage.proPrefix; // 生产环境
// 开发环境接口提供
export const clientUrlAPI = window.dataManage.devPrefix // 客户端前端api地址
export const cpeosFixUrlAPI = window.dataManage.cpeosFix // 客户端前端api地址

